import { UD_DESCRIPTIONS, UD_TYPES } from './constants';
import { getUdDescriptionInGrammarTypeByLang, throwError } from './utils';

export const toUdObject = (value: number, udType: string) => {
  if (!Object.entries(UD_TYPES).find(([k, v]) => v === udType)) {
    throwError();
  }

  const enDescription = `${value} ${getUdDescriptionInGrammarTypeByLang(value, UD_DESCRIPTIONS[udType].en)}`;
  const esDescription = `${value} ${getUdDescriptionInGrammarTypeByLang(value, UD_DESCRIPTIONS[udType].es)}`;
  const shortDescription = `${value} ${UD_DESCRIPTIONS[udType].short}`;

  return {
    value,
    ud: udType,
    description: {
      en: enDescription,
      es: esDescription,
      de: enDescription,
      fr: enDescription,
      it: enDescription,
      us: enDescription,
    },
    shortDescription: {
      en: shortDescription,
      es: shortDescription,
      de: shortDescription,
      fr: shortDescription,
      it: shortDescription,
      us: shortDescription,
    },
  };
};
